import { AutogenModelCopyControlMulticompanySearch, AutogenRowCopyControlMulticompanySearch } from "./autogen/AutogenModelCopyControlMulticompanySearch";

export class ModelCopyControlMulticompanySearch extends AutogenModelCopyControlMulticompanySearch<RowCopyControlMulticompanySearch> {
	constructor() {
		super(RowCopyControlMulticompanySearch);
	}
}

export class RowCopyControlMulticompanySearch extends AutogenRowCopyControlMulticompanySearch {
}